import React, {Component} from 'react';

class TopImagesCarousel extends Component {
    displayImages = () => {
        const {topImages} = this.props;

        return topImages.map((image, idx) => {
            const carouselStyle = {
                backgroundImage: `url(${image.thumbnail_url})`
            };

            return (
                <div
                    className={`carousel-img carousel-img-${idx}`}
                    style={carouselStyle}
                    key={idx}
                />
            );
        });
    };

    render() {
        const {renderForPdf} = this.props;
        const images = this.displayImages();

        return (
            <div className="header-body-carousel">
                {images}

                {/*STYLES*/}

                <style>{`
                    .header-body-carousel {
                        position: relative;
                        width: 60%;
                        overflow: hidden;
                    }

                    .carousel-img {
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: cover;
                        border-radius: 5px;
                        position: absolute;
                        z-index: 2;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .header-body-carousel {
                            display: flex;
                            height: 760px;
                        }

                        .carousel-img-0 {
                            width: 480px;
                            height: 480px;
                            top: 160px;
                            right: 0;
                        }

                        .carousel-img-1 {
                            width: 200px;
                            height: 200px;
                            top: 0;
                            right: 420px;
                        }

                        .carousel-img-2 {
                            width: 160px;
                            height: 160px;
                            top: 600px;
                            right: 440px;
                            z-index: 1;
                        }

                        .carousel-img-3 {
                            width: 140px;
                            height: 140px;
                            top: 60px;
                            right: 0;
                        }

                        .carousel-img-4 {
                            width: 100px;
                            height: 100px;
                            top: 350px;
                            right: 560px;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .header-body-carousel {
                            width: 100%;
                            height: 912px;
                        }

                        .carousel-img-0 {
                            width: 576px;
                            height: 657px;
                            top: 192px;
                            right: 0;
                        }

                        .carousel-img-1 {
                            width: 240px;
                            height: 240px;
                            top: 0;
                            right: 504px;
                        }

                        .carousel-img-2 {
                            width: 192px;
                            height: 192px;
                            top: 720px;
                            right: 528px;
                            z-index: 1;
                        }

                        .carousel-img-3 {
                            width: 168px;
                            height: 168px;
                            top: 72px;
                            right: 0;
                        }

                        .carousel-img-4 {
                            width: 120px;
                            height: 120px;
                            top: 420px;
                            right: 672px;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

TopImagesCarousel.propTypes = {};

export default TopImagesCarousel;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/campaign_wrap_up_header/top_images_carousel.js